module.exports = __webpack_public_path__ + "img/horizontal_7_3_8023.9fb0114c.png";